import { BackButtonContainer } from './style';

interface BackButtonProps {
  onClick: () => void;
}

export default function BackButton({ onClick }: BackButtonProps) {
  return (
    <BackButtonContainer
      type="button"
      onClick={onClick}
      aria-label="Voltar para etapa anterior"
    >
      ← Voltar
    </BackButtonContainer>
  );
}
